export const PiggyGrow = () => (
  <div className="piggy-scene relative h-40 w-44" data-testid="piggy-grow" aria-hidden>
    {[0, 1, 2].map((i) => (
      <svg key={i} viewBox="0 0 24 24" className="piggy-coin absolute left-1/2 top-0 h-6 w-6" style={{ animationDelay: `${i * 1.3}s` }}>
        <circle cx="12" cy="12" r="10" fill="#E2C46E" stroke="#A8893F" strokeWidth="1.5" />
        <text x="12" y="16" textAnchor="middle" fontSize="11" fontWeight="800" fill="#7A5F1F">€</text>
      </svg>))}
    <svg viewBox="0 0 160 120" className="piggy-body absolute bottom-0 left-1/2 h-32 w-40">
      <defs>
        <linearGradient id="pigG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#FFC7D6" /><stop offset="1" stopColor="#F28AA8" /></linearGradient>
      </defs>
      <ellipse cx="80" cy="112" rx="46" ry="5" fill="#000" opacity="0.12" />
      <rect x="44" y="88" width="14" height="22" rx="6" fill="#E77A99" />
      <rect x="98" y="88" width="14" height="22" rx="6" fill="#E77A99" />
      <ellipse cx="80" cy="66" rx="58" ry="40" fill="url(#pigG)" />
      <path d="M46 34 L54 14 L66 30 Z" fill="#F28AA8" />
      <ellipse cx="134" cy="66" rx="13" ry="11" fill="#F7A3BB" />
      <circle cx="130" cy="64" r="2.4" fill="#B4506F" /><circle cx="138" cy="64" r="2.4" fill="#B4506F" />
      <circle cx="112" cy="50" r="4" fill="#3A2230" />
      <rect x="66" y="27" width="28" height="5" rx="2.5" fill="#B4506F" />
      <path d="M22 62 q-12 -4 -8 -14" stroke="#F28AA8" strokeWidth="4" fill="none" strokeLinecap="round" />
      <ellipse cx="62" cy="50" rx="14" ry="7" fill="#fff" opacity="0.35" />
    </svg>
  </div>
);
